import './highcharts';
import 'highcharts/es-modules/masters/modules/boost.src.js';
import { Chart } from './Chart';
import type { ChartProps } from './Chart';

/**
 * Loads the Highcharts boost module before rendering the shared Seeq chart
 * wrapper.
 */
export const BoostChart = ({ onReady, options, ...rest }: ChartProps) => {
  return <Chart {...rest} options={options} onReady={onReady} />;
};
